<div class="frame">
  <div #container class="container">
    <div style="text-align: center; padding-top: 20%; font-size: 0.9em">
      looks like the player is already installed, please launch it...
      <br/>
      <br/>
      <div style="text-align: center">
        <mat-icon style="font-size: 50px">restart_alt</mat-icon>
      </div>
    </div>
  </div>
</div>

